import { lazy } from 'react';

export const LessonsCompletedScreenLazy = lazy(async () => {
  const { LessonsCompletedScreen } = await import('./lessons-completed.screen.tsx');
  return { default: LessonsCompletedScreen };
});
